import 'zone.js';
import 'reflect-metadata';
import '@angular/localize/init';